module.exports = __webpack_public_path__ + "static/media/PATHWAY SHED.aafdfd5c.jpg";